/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormQualityEntry } from '../../models/form-quality-entry';
import { FormQualityEntryCreateDto } from '../../models/form-quality-entry-create-dto';

export interface CreateFormQualityEntry$Params {
  formId: string;
  body: FormQualityEntryCreateDto;
}

export function createFormQualityEntry(
  http: HttpClient,
  rootUrl: string,
  params: CreateFormQualityEntry$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<FormQualityEntry>> {
  const rb = new RequestBuilder(rootUrl, createFormQualityEntry.PATH, 'post');
  if (params) {
    rb.path('formId', params.formId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FormQualityEntry>;
    })
  );
}

createFormQualityEntry.PATH = '/forms/{formId}/quality-entry';
